// extracted by mini-css-extract-plugin
module.exports = {"captchaWrapper":"styles_captchaWrapper__fJ0SA","geetest":"styles_geetest__Z0fuq"};